/**
 * Invoice-related strings.
 */
import React from 'react';
import Icons from '../ui/IconButton/Icons';
import FontAwesomeButton from "../ui/Buttons/FontAwesomeButton";
import RoutedIconButton from "../ui/Buttons/RoutedIconButton";

export default {
    // Invoices.js
    d_deleteInvoice: <span>Are you sure you want to delete this invoice? It will delete all associated entries!</span>,
    d_invoices: 'Invoices',
    h_invoices: <div>
        <div>The <b>Invoices</b> section lists all invoices, both draft and finalized.</div>
        <div>By default, all finalized invoices are hidden. Uncheck the <b>Hide Finalized</b> checkbox to show them.</div>
        <div className='u-row u-wrap'>To configure invoicing, including billable increments, rounding method and invoice formatting, click on
            the <FontAwesomeButton icon={Icons.CONFIG.reactIcon} label='Configure' route='/config/financial/invoicing?div=billing'/> button to the right.
        </div>
    </div>,

    // InvoiceCard.js


    // InvoiceDetail.js
    d_date: 'Date',
    d_notes: 'Notes',
    h_notes: <div>This text will be displayed as comments at the end of the invoice. You can set up a default
        message in <RoutedIconButton type={Icons.CONFIG}
                                     title='Configure Invoicing'
                                     route='/config/financial/invoicing'
                                     label='Invoice Configuration'/>
    </div>,
    d_time: 'Time',
    d_rate: 'Rate',
    d_endDate: 'End Date',
    h_endDate: 'The last day of billing for this invoice.',

    d_invoice: 'Invoice',
    h_invoice: 'The related invoice. Click on the icon to see the invoice.',

	d_courtInvoice: 'Court Invoice',
	h_courtInvoice: 'Court invoices include an additional table of user time and cost, based not on actual costs but rather on their actual time and billing rates for this case. This content is visible in Preview mode as well as printed and saved invoices after the Labor and/or Flat Fee sections.',

    d_paid: 'Paid',
    d_unpaid: 'Unpaid',
    d_collected: (params: {collectedF: number, billedF: number, dueF: number}) =>
        `${params.collectedF} of ${params.billedF} paid\u000a${params.dueF} remaining`,

    d_flagged: 'Flagged',

    d_case: 'Case',
    d_clients: 'Client(s)',

    d_discountsOverride: 'Discounts',
    d_discounts: 'Discounts -- Resist the Temptation!',
    h_discounts: `<div>There are almost always better ways to handle an upset client than giving discounts! Remember that most clients are interested in predictable billing. Before you start discounting your time, consider these options: <ul><li>Use narrative-style invoicing, where the client only sees a highly detailed work summary, rather than a detailed minute-by-minute breakdown of every penny. Narrative-style billing takes the focus off of your hourly billing rate, and focuses instead on the work that you have done on the client's case.</li><li>If clients are struggling to pay your invoices, consider reducing the scope of your representation.</li><li>Consider using an alternative fee arrangement, such as flat fee billing.</li><li>Ensure your invoices are sent out regularly, and if you know the invoice will be for more than the client is expecting, call them first and let them know what to expect.</li></ul><div>Time is money in this line of work, when you discount your time you discount yourself!</div></div>`,

    // InvoiceSummary.js

};
